import { render, staticRenderFns } from "./PptAttrPanel.vue?vue&type=template&id=18de96f1&"
import script from "./PptAttrPanel.vue?vue&type=script&lang=js&"
export * from "./PptAttrPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/items/PptAttrPanel.vue"
export default component.exports